module.exports = __webpack_public_path__ + "img/album08_06.da700bd2.jpg";